import { useLang } from "@/context/LanguageContext";
import { Leaf, Instagram, Twitter, Linkedin } from "lucide-react";

export default function Footer() {
  const { t } = useLang();

  const sections = [
    {
      title: t.footer.product,
      links: [
        { label: t.footer.links.features, href: "#features" },
        { label: t.footer.links.pricing, href: "#pricing" },
        { label: t.footer.links.templates, href: "#" },
        { label: t.footer.links.roadmap, href: "#" },
      ],
    },
    {
      title: t.footer.company,
      links: [
        { label: t.footer.links.about, href: "#" },
        { label: t.footer.links.blog, href: "#" },
        { label: t.footer.links.careers, href: "#" },
        { label: t.footer.links.contact, href: "#" },
      ],
    },
    {
      title: t.footer.legal,
      links: [
        { label: t.footer.links.terms, href: "#" },
        { label: t.footer.links.privacy, href: "#" },
        { label: t.footer.links.cookies, href: "#" },
      ],
    },
  ];

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#064E3B] text-[#FDFBF7] pt-20 md:pt-28 pb-12"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="lg:col-span-5">
            <a href="#top" className="flex items-center gap-2">
              <span className="w-10 h-10 rounded-2xl bg-[#22C55E] flex items-center justify-center">
                <Leaf className="w-5 h-5 text-white" strokeWidth={2.5} />
              </span>
              <span className="font-heading text-3xl font-black tracking-tight text-white">
                staysy
                <span className="text-[#22C55E]">.</span>
              </span>
            </a>
            <p
              data-testid="footer-tagline"
              className="mt-5 max-w-md font-body text-base text-white/70 leading-relaxed"
            >
              {t.footer.tagline}
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[
                { Icon: Instagram, label: "instagram" },
                { Icon: Twitter, label: "twitter" },
                { Icon: Linkedin, label: "linkedin" },
              ].map(({ Icon, label }) => (
                <a
                  key={label}
                  href="#"
                  data-testid={`footer-social-${label}`}
                  className="w-11 h-11 rounded-full bg-white/10 hover:bg-[#22C55E] flex items-center justify-center transition-colors duration-300"
                  aria-label={label}
                >
                  <Icon className="w-4 h-4 text-white" />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          {sections.map((s) => (
            <div key={s.title} className="lg:col-span-2">
              <h4 className="font-heading text-sm font-black uppercase tracking-wider text-white/90">
                {s.title}
              </h4>
              <ul className="mt-5 space-y-3">
                {s.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="font-body text-sm text-white/70 hover:text-[#22C55E] transition-colors"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Newsletter mini */}
          <div className="lg:col-span-3">
            <h4 className="font-heading text-sm font-black uppercase tracking-wider text-white/90">
              Hello@staysy
            </h4>
            <p className="mt-5 font-body text-sm text-white/70 leading-relaxed">
              hello@staysy.cz
              <br />
              +420 800 800 800
              <br />
              Karlovo nám. 5, Praha
            </p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p
            data-testid="footer-copyright"
            className="font-body text-sm text-white/60"
          >
            {t.footer.copyright}
          </p>
          <p className="font-body text-xs text-white/40">
            Made with <span className="text-[#22C55E]">●</span> for hospitality.
          </p>
        </div>
      </div>
    </footer>
  );
}
